import { render, staticRenderFns } from "./PrivateRate.vue?vue&type=template&id=6ad1eb38&"
import script from "./PrivateRate.vue?vue&type=script&lang=js&"
export * from "./PrivateRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports